import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SaunaIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SaunaIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.4286 22.1689C5.20784 22.1689 3.00049 19.6721 3.00049 17.5347C3.00049 15.1761 5.28629 13.4932 9.11439 13.0322L9.25626 13.0151L9.39122 13.0607C11.686 13.846 14.7462 14.0591 16.7137 13.5387L16.8629 13.4997L17.0133 13.5347C18.8068 13.9469 22.9788 15.1623 22.9788 17.5347C22.9788 20.5185 16.1494 22.1689 11.4286 22.1689ZM9.12537 14.2891C6.11354 14.6818 4.24929 15.9192 4.24929 17.5347C4.24929 19.5599 7.13429 20.9201 11.4286 20.9201C16.8799 20.9201 21.73 19.0266 21.73 17.5347C21.73 16.7583 20.2109 15.5753 16.8795 14.7851C14.7246 15.3127 11.5713 15.0956 9.12537 14.2891Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1606 15.0822C12.4325 15.0822 10.5472 14.7765 8.98738 14.2432C6.63654 13.4391 5.3418 12.2765 5.3418 10.9691C5.3418 9.51952 6.94914 8.23983 9.75121 7.45851L9.9756 7.39591L10.1858 7.49591C10.7297 7.75282 11.4106 7.88291 12.2094 7.88291C13.4273 7.88291 14.7452 7.5764 15.7342 7.06257L15.9167 6.96826L16.12 7.00078C18.9489 7.44957 20.6379 8.93333 20.6379 10.9691C20.6379 12.7375 19.2903 14.1497 17.0334 14.7464C16.1915 14.9692 15.2249 15.0822 14.1606 15.0822ZM9.8752 8.72277C7.93046 9.30083 6.5906 10.2114 6.5906 10.9691C6.5906 11.6578 7.68998 12.4794 9.39122 13.0607C11.686 13.846 14.7462 14.0591 16.7137 13.5387C18.4137 13.0891 19.3891 12.1529 19.3891 10.9692C19.3891 9.6423 18.1708 8.63985 16.1184 8.26668C14.9854 8.81059 13.5419 9.13173 12.2094 9.13173C11.3252 9.13173 10.5415 8.99432 9.8752 8.72277Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.2094 9.13173C11.2248 9.13173 10.3639 8.96093 9.65216 8.62434C8.40052 8.03409 7.68262 6.9544 7.68262 5.6617C7.68262 3.93403 9.08223 2.19092 12.2091 2.19092C15.088 2.19092 18.2962 3.61614 18.2962 5.6617C18.2962 6.61456 17.5905 7.50563 16.3096 8.17149C15.1506 8.77231 13.6183 9.13173 12.2094 9.13173ZM12.2091 3.43971C10.1875 3.43971 8.93141 4.29094 8.93141 5.66169C8.93141 6.46251 9.37654 7.11374 10.1851 7.49505C10.7294 7.75278 11.4106 7.88291 12.2094 7.88291C13.4273 7.88291 14.7452 7.5764 15.7342 7.06257C16.5566 6.63574 17.0474 6.1121 17.0474 5.66169C17.0474 4.682 14.7693 3.43971 12.2091 3.43971Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SaunaIcon;
